import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Button from './Button';
var useStyles = makeStyles(function (theme) { return ({
    button: {
        textTransform: 'none',
        height: theme.spacing(4),
    },
}); });
export var defaultLabels = {
    clear: 'Clear',
    find: 'Find',
};
var FilterActions = function (_a) {
    var labels = _a.labels, fetching = _a.fetching, onClear = _a.onClear;
    var classes = useStyles();
    return (React.createElement(Grid, { container: true, justify: "flex-end", alignItems: "center", spacing: 1 },
        React.createElement(Grid, { item: true, xs: 4, sm: 2 },
            React.createElement(Button, { className: classes.button, fullWidth: true, variant: "outlined", onClick: onClear }, labels && labels.clear)),
        React.createElement(Grid, { item: true, xs: 4, sm: 2 },
            React.createElement(Button, { fullWidth: true, className: classes.button, type: "submit", color: "primary", variant: "outlined", disabled: fetching },
                fetching && React.createElement(CircularProgress, { color: "inherit", size: 20 }),
                labels && labels.find))));
};
FilterActions.defaultProps = {
    labels: defaultLabels,
    fetching: false,
    onClear: function () { },
};
export default FilterActions;
//# sourceMappingURL=FilterActions.js.map